import { useRoutePersistence } from '@hooks/useRoutePersistence';

interface RoutePersistenceWrapperProps {
  children: React.ReactNode;
}

const RoutePersistenceWrapper = ({
  children,
}: RoutePersistenceWrapperProps) => {
  useRoutePersistence();

  return <>{children}</>;
};

export default RoutePersistenceWrapper;
